import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/common/components/UiComponent/CustomCollapse.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/Buttons/InputOutputActionButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/HtmlTags/H2Tag/H2Tag.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/HtmlTags/PTag/PTag.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/HtmlTags/H1Tag/H1Tag.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["RelevantTools"] */ "/vercel/path0/src/components/common/RelevantTools/RelevantTools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyToClip"] */ "/vercel/path0/src/components/tools/helper/CopyToClip/CopyToClip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/tools/helper/ToolOverview/ToolDescription.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["JSONToTypescript"] */ "/vercel/path0/src/components/tools/JsonTools/JSONToTypescript/JSONToTypescript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/tools/ToolsList/ToolsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useGetUrlPath"] */ "/vercel/path0/src/hooks/useGetUrl.ts");
